"use strict";

class StationSettingsPrintEpgCtrl {
    constructor($rootScope, $http, $mdToast, $mdDialog, $state, $transitions) {
        this.$rootScope = $rootScope;
        this.$http = $http;
        this.$mdToast = $mdToast;
        this.$mdDialog = $mdDialog;
        this.$state = $state;

        this.status = {saving: false, errors: false};
        this.epgTemplates = [];
        this.fetch();

        this.isSaved = false;
        this.firstVisit = true;

        this.$rootScope.saveDisabled = false;
        this.$rootScope.saveHiden = false;
        this.$rootScope.save = this.save.bind(this);

        this.unregisterStateChangeStart = $transitions.onStart({ }, this.stateChangeStart.bind(this));

    }

    stateChangeStart(transition) {

        let to = transition.to();
        let toParams = transition.params();

        if (!angular.equals(this.copyEpgTemplate, this.currentEpgTemplate) && this.isSaved == false) {
            transition.abort();
            this.$mdDialog.show({
                controller: 'ConfirmDialogCtrl',
                templateUrl: "unsavedDataDialog.ngTemplate",
                parent: angular.element(document.querySelector('#popupContainer')),
                clickOutsideToClose: true
            }).then(() => {
                this.isSaved = true;
                this.$state.go(to, toParams);
            });
        }
    }

    fetch() {
        this.epgTemplates = [];
        this.$http.get('print/templates_epg').then(response => {
            this.epgTemplates = response.data;

            if (this.$state.params.epgTemplateId) {

                this.currentEpgTemplate = this.epgTemplates[this.$state.params.epgTemplateId];
                this.currentIndex = this.$state.params.epgTemplateId;

                this.copyEpgTemplate = angular.copy(this.currentEpgTemplate);
            }
        });
    }

    save() {
        return new Promise((resolve) => {
            if (this.currentEpgTemplate.id) {
                this.$http.put('print/templates_epg', this.currentEpgTemplate)
                    .then((response) => {
                        this.$mdToast.show({
                            templateUrl: '/partial/app.partials.toasts.object_saved?object=template', //@trans('labels.settings')
                            hideDelay: 6000,
                            position: ('top right')
                        });

                        this.fetch();

                        this.isSaved = true;

                        this.epgTemplates[this.currentIndex] = response.data;

                        resolve();
                    });
            } else {
                this.$http.post('print/templates_epg', this.currentEpgTemplate)
                    .then((response) => {
                        this.$mdToast.show({
                            templateUrl: '/partial/app.partials.toasts.object_saved?object=template', //@trans('labels.settings')
                            hideDelay: 6000,
                            position: ('top right')
                        });

                        this.fetch();

                        this.isSaved = true;

                        this.epgTemplates[this.currentIndex] = response.data;

                        resolve();
                    });
            }
        });
    }

    addEpgTemplate() {
        let indexContent = {
            title: 'template',
            body: `{#

If you want to see all requested broadcast/item data or already defined varia, you can use:

{{ dump() }}

Looking for something specific? You can set an parameter in debug function like this:

{{ dump(station.name) }}
{{ dump(days) }} or if you want to get the first day of an array {{ dump(days|first) }}
{{ dump(hours) }}

#}
<!DOCTYPE html>
<html moznomarginboxes mozdisallowselectionprint>
<head>
    <title>{{broadcast.title}} - template</title>
    <link href="https://fonts.googleapis.com/css?family=Roboto:100,100i,300,300i,400" rel="stylesheet"/>
    <style type="text/css">
        * {
            margin: 0;
            font-family: 'Roboto', sans-serif;
        }

        .header {
            text-align: center;
            font-size: 8pt;
            padding: 0;
            margin: 0 0 1em 0;
        }

        .timespace {
            width: 50px;
            position: relative;
            display: inline-block;
        }

        .date {
            display: flex;
            padding-bottom: 1em;
            font-weight: lighter;
            color: black;
        }

        .date span {
            font-size: 1.3rem;
            width: calc((100% - 50px) / 7);
            text-align: center;
        }

        .date .space {
            width: 50px;
        }

        .timespace time {
            padding: 0 1em 0 0;
            position: absolute;
            font-weight: lighter;
            color: #8f949b;
        }

        .content {
            display: flex;
            flex-wrap: wrap;
            flex: 1;
        }

        .day {
            width: calc((100% - 50px - (1px * 14)) / 7);
            display: inline;
            padding: 0 1px;
            position: relative;
        }

        .day-item {
            padding: .2em .5em 0 .5em;
            position: absolute;
            width: calc(100% - 20px);
            overflow: hidden;
        }
        
        .subBroadcast {
            z-index: 1;
            width: 80%;
            left: calc(10% - 4px);
        }

        .broadcast h3, .broadcast p {
            font-size: .8rem;
            color: white;
            word-wrap: break-word;
        }
        
        .broadcast time {
            color: white;
            font-size: .7rem;
        }
        
        .broadcast .presenters {
            color: white;
            font-size: .6rem;
        }

        @page {
            size: A4 landscape;
            size: 287mm 210mm;
        }
        
        @media print and (color) {
           * {
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
           }
        }

        .broadcast {
            border-radius: 0.5em;
            box-shadow: 2px 2px 0 0 rgba(25, 25, 25, 0.4);
        }
    </style>
</head>
<body>
<main class="container">
    <div class="header">
    <h1>{{station.name}}</h1>
    </div>
    <div class="date">
        <span class="space"></span>
        {% for date, day in days %}
        <span>{{ date }}</span>
        {% endfor %}
    </div>
    <div class="content">
        <div class="timespace">
            {% for key, hour in hours  %}
            <time style="top: calc(50px * {{key}})">{{hour}}</time>
            {% endfor %}
        </div>
        {% for day in  days %}
        <div class="day">
            {% for broadcast in day.broadcasts %}
            <div 
            style="background-color: {{broadcast.model_type.options.color}}; height: calc({{broadcast.durationFloat}} * 50px); top: calc({{broadcast.startFloat}} * 50px);" 
            class="day-item broadcast {% if broadcast.model_type.options.subBroadcast == true %} subBroadcast {% endif %}">
                <time>{{broadcast.originalStart.date|date('H:i')}} - {{broadcast.originalStop.date|date('H:i')}}</time>
                <h3>{{broadcast.title}}</h3>
                {% for presenter in broadcast.presenters %}
                <h5 class="presenters">{{presenter.name}}</h5>
                {% endfor %}
                <p>{{broadcast.description}}</p>
            </div>
            {% endfor %}
        </div>
        {% endfor %}
    </div>
</main>
</body>
</html>`
        };

        if (this.isSaved == false && this.firstVisit == false) {
            event.preventDefault();
            this.$mdDialog.show({
                controller: 'ConfirmDialogCtrl',
                templateUrl: "unsavedDataDialog.ngTemplate",
                parent: angular.element(document.querySelector('#popupContainer')),
                clickOutsideToClose: true
            }).then(() => {
                let length = this.epgTemplates.push(indexContent);

                this.openEpgTemplate(length - 1);

                this.isSaved = false;
            });
        } else {
            let length = this.epgTemplates.push(indexContent);

            this.openEpgTemplate(length - 1);

            this.firstVisit = false;
            this.isSaved = false;
        }
    }

    openEpgTemplate(index) {
        this.currentEpgTemplate = this.epgTemplates[index];
        this.currentIndex = index;

        this.copyEpgTemplate = angular.copy(this.currentEpgTemplate);

        this.$state.transitionTo('stationsettings.print_templates.print_epg.epgTemplate', {epgTemplateId: index});
    }


    checkActiveSlide(index) {
        return this.$state.params.slideId == index;
    }

    sanitizeVisualName() {
        if (this.currentEpgTemplate.title) {
            this.currentEpgTemplate.title = this.currentEpgTemplate.title.trim().replace(/[^\w\d_]/gi, '').toLowerCase();
        }
    }

    preview(epgTemplate, ev) {
        this.save().then(() => {
            this.$mdDialog.show({
                controller: 'PrintEpgCtrl',
                templateUrl: 'previewEpgDialog.ngTemplate',
                targetEvent: ev,
                clickOutsideToClose: true,
                locals:{templateId: this.epgTemplates[this.currentIndex].id},
            });
        });
    }

    destroy(epgTemplate, ev, index) {
        this.$mdDialog.show({
            controller: 'ConfirmDialogCtrl',
            templateUrl: 'confirmDialog.ngTemplate',
            //parent: angular.element(document.querySelector('#popupContainer')),
            targetEvent: ev,
            clickOutsideToClose: true
        }).then(() => {
            if (epgTemplate.id) {
                this.$http.delete('print/templates_epg/' + epgTemplate.id);
            }

            this.epgTemplates.splice(index, 1);

            if (this.currentIndex === index) {
                this.$state.transitionTo('stationsettings.print_templates.print_epg.epgTemplate');
            }
        });
    }

    openMenu($mdOpenMenu, ev) {
        $mdOpenMenu(ev);
    }
}


StationSettingsPrintEpgCtrl.$inject = ['$rootScope', '$http', '$mdToast', '$mdDialog', '$state', '$transitions'];


module.exports = StationSettingsPrintEpgCtrl;
